import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { localizeDate } from '@/utils/vuex';
import { mapState } from 'vuex';
import ApiService from '../../../services/apiService';
export default {
  name: 'CoreConnectorsStatusLogs',
  props: {
    connectorId: {
      type: [String, Number],
      required: true
    }
  },
  data: function data() {
    return {
      isLoadingLogs: false,
      connectorLogs: [],
      logItemPayload: null,
      activeItemIndex: -1,
      lastRefreshed: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['color'])), {}, {
    hasNoPackets: function hasNoPackets() {
      return this.connectorLogs.length === 0;
    }
  }),
  mounted: function mounted() {
    this.fetchConnectorLogs();
  },
  methods: {
    localizeDate: localizeDate,
    isJsonPayload: function isJsonPayload(payload) {
      try {
        JSON.parse(JSON.stringify(payload));
      } catch (e) {
        return false;
      }

      return true;
    },
    getLogLevelColor: function getLogLevelColor(level) {
      switch (level) {
        case 'error':
          return 'danger';

        case 'warn':
          return 'warning';

        case 'info':
          return 'primary';

        default:
          return 'primary';
      }
    },
    getLogLevelIcon: function getLogLevelIcon(level) {
      switch (level) {
        case 'error':
          return 'fa-exclamation-circle';

        case 'warn':
          return 'fa-exclamation-triangle';

        case 'info':
          return 'fa-info-circle';

        default:
          return 'fa-check-circle';
      }
    },
    handleItemSelected: function handleItemSelected(item) {
      this.activeItemId = item.id;
      this.logItemPayload = item.payload;
    },
    fetchConnectorLogs: function fetchConnectorLogs() {
      var _this = this;

      this.isLoadingLogs = true;
      this.logItemPayload = null;
      ApiService.getBridgeLogs(this.connectorId).then(function (response) {
        _this.lastRefreshed = new Date();
        _this.connectorLogs = response;

        if (_this.connectorLogs.length > 0) {
          _this.handleItemSelected(_this.connectorLogs[0]);
        }
      }).catch(function (error) {
        _this.$snack(_this.$i18n_t('Connectors.Connectors.statusLogs.error'), 'error');

        console.error(error);
      }).finally(function () {
        _this.isLoadingLogs = false;
      });
    }
  }
};